const isFTSP = process.env.MIX_FACULTY_LABEL === 'FTSP';

export const nilai = {
    // Konversi nilai angka rerata menjadi nilai huruf
    huruf: (nilaiAngka) => {
        const angka = parseFloat(nilaiAngka);
        if (isNaN(angka)) return '';
        const rerata = Math.round(angka * 100) / 100;
        if (rerata >= 80) return 'A';
        if (rerata >= 77.5) return 'A-';
        if (rerata >= 75) return 'A/B';
        if (rerata >= 72.5) return 'B+';
        if (rerata >= 70) return 'B';
        if (rerata >= 67.5) return 'B-';
        if (rerata >= 65) return 'B/C';
        if (rerata >= 62.5) return 'C+';
        if (rerata >= 60) return 'C';
        if (rerata >= 55) return 'C-';
        if (rerata >= 50) return 'C/D';
        if (rerata >= 45) return 'D+';
        if (rerata >= 40) return 'D';
        return 'E';
    },

    // Nilai akhir rubrik = jumlah dari (bobot% x nilai) tiap komponen
    akhirRubrik: (komponen) => {
        if (!komponen || komponen.length === 0) return null;
        const terisi = komponen.some(item => item.nilai !== null && item.nilai !== undefined && item.nilai !== '');
        if (!terisi) return null;
        const total = komponen.reduce((sum, item) => {
            const bobot = parseFloat(item.bobot) || 0;
            const angka = parseFloat(item.nilai) || 0;
            return sum + (bobot / 100 * angka);
        }, 0);
        return Math.round(total * 100) / 100;
    },

    // Format tampilan nilai akhir, contoh: 80.00 (A)
    format: (nilaiAngka, nilaiHuruf) => {
        if (nilaiAngka === null || nilaiAngka === undefined || nilaiAngka === '') return '-';
        const angka = parseFloat(nilaiAngka);
        if (isNaN(angka)) return nilaiAngka;
        return angka.toFixed(2) + ' (' + (nilaiHuruf || nilai.huruf(angka)) + ')';
    },

    // Tampilan nilai sesuai fakultas: FTSP 80.00 (A), selain itu 80/A
    tampil: (nilaiAngka, nilaiHuruf) => {
        if (isFTSP) return nilai.format(nilaiAngka, nilaiHuruf);
        return nilaiAngka ? nilaiAngka + (nilaiHuruf ? '/' + nilaiHuruf : '') : '-';
    }
};
